var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKingdomTower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 788,
    height: 618,
    viewBox: "0 0 788 618",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.5,
    y: 443.5,
    width: 79,
    height: 117,
    fill: "#22d3ee",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.5,
    y: 273.5,
    width: 79,
    height: 287,
    fill: "#22d3ee",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 718.5,
    y: 268.5,
    width: 79,
    height: 292,
    fill: "#22d3ee",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 614.5,
    y: 398.5,
    width: 103,
    height: 162,
    fill: "#22d3ee",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 548.5,
    y: 318.5,
    width: 65,
    height: 242,
    fill: "#22d3ee",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 379.5,
    width: 59,
    height: 181,
    fill: "#22d3ee",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 291.5,
    width: 79,
    height: 269,
    fill: "#22d3ee",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 17,
    width: 171,
    height: 544,
    fill: "#22d3ee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.202 560.999C286.253 560.636 325.788 452.278 325.788 21.2307L326 560.999H266.202C266.134 561 266.067 561 266 560.999H266.202Z",
    fill: "#005340"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.5,
    cy: 17,
    rx: 85.5,
    ry: 12,
    fill: "#22d3ee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.982 230.269C177.13 197.883 166.569 88.6863 168.146 38.1364C252.67 4.0795 310.004 38.1364 313.551 38.1364C317.097 38.1364 300.547 270.751 231.982 230.269Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.12 38.1646L172.25 35C170.271 92.3248 182.368 212.58 246 235C179.994 224.299 166.537 100.373 168.12 38.1646Z",
    fill: "#7B7171"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 787.5,
    y: 268.5,
    width: 10,
    height: 260,
    fill: "#005340"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 787.5,
    y: 268.5,
    width: 10,
    height: 260,
    fill: "#005340"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 787.5,
    y: 268.5,
    width: 10,
    height: 260,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 707.5,
    y: 398.5,
    width: 10,
    height: 130,
    fill: "#005340"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 707.5,
    y: 398.5,
    width: 10,
    height: 130,
    fill: "#005340"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 707.5,
    y: 398.5,
    width: 10,
    height: 130,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.5,
    y: 318.5,
    width: 15,
    height: 210,
    fill: "#005340"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.5,
    y: 318.5,
    width: 15,
    height: 210,
    fill: "#005340"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.5,
    y: 318.5,
    width: 15,
    height: 210,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.5,
    y: 273.5,
    width: 16,
    height: 255,
    fill: "#005340"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.5,
    y: 273.5,
    width: 16,
    height: 255,
    fill: "#005340"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.5,
    y: 273.5,
    width: 16,
    height: 255,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.5,
    y: 443.5,
    width: 10,
    height: 85,
    fill: "#005340"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.5,
    y: 443.5,
    width: 10,
    height: 85,
    fill: "#005340"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.5,
    y: 443.5,
    width: 10,
    height: 85,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 291.5,
    width: 10,
    height: 237,
    fill: "#005340"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 291.5,
    width: 10,
    height: 237,
    fill: "#005340"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 291.5,
    width: 10,
    height: 237,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.5,
    y: 291.5,
    width: 18,
    height: 237,
    fill: "#005340"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.5,
    y: 291.5,
    width: 18,
    height: 237,
    fill: "#005340"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.5,
    y: 291.5,
    width: 18,
    height: 237,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 379.5,
    width: 10,
    height: 149,
    fill: "#005340"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 379.5,
    width: 10,
    height: 149,
    fill: "#005340"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 379.5,
    width: 10,
    height: 149,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.5,
    y: 291.5,
    width: 79,
    height: 269,
    fill: "#22d3ee",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 529.5,
    width: 797,
    height: 88,
    fill: "#22d3ee",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.5,
    y: 291.5,
    width: 10,
    height: 237,
    fill: "#005340"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.5,
    y: 291.5,
    width: 10,
    height: 237,
    fill: "#005340"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.5,
    y: 291.5,
    width: 10,
    height: 237,
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 788,
    height: 618,
    fill: "#22d3ee"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKingdomTower);
export default __webpack_public_path__ + "static/media/kingdom-tower.bcbaa11b0ebbda42e555a624a85e030f.svg";
export { ForwardRef as ReactComponent };